import React from 'react';
import { Check, MoneyOff, CurrencyExchange } from '@mui/icons-material';
import { MITStatus } from '../../store/modules/mit/types';
import { colorDisabled, colorSuccess, colorError, StatusColor } from '../../util/constants';

const StatusUiMapper: Record<MITStatus, { icon: JSX.Element; color: StatusColor }> = {
  PAID: { icon: <Check />, color: colorSuccess },
  FAILED: { icon: <MoneyOff />, color: colorError },
  PARTIALLY_REFUNDED: { icon: <CurrencyExchange />, color: colorSuccess },
  REFUNDED: { icon: <CurrencyExchange />, color: colorSuccess },
};

export const getMITStatusUi = (status: MITStatus) => {
  return (
    StatusUiMapper[status] ?? {
      icon: <Check />,
      color: colorDisabled,
    }
  );
};

const StatusLabelMapper: Record<MITStatus, string> = {
  PAID: 'Paid',
  FAILED: 'Failed',
  PARTIALLY_REFUNDED: 'Partially Refunded',
  REFUNDED: 'Fully Refunded',
};

export const getMITStatusLabel = (status: MITStatus) => {
  return StatusLabelMapper[status] ?? 'Unknown';
};

export const getMITStatusBackgroundColor = (status: MITStatus) => {
  return getMITStatusUi(status).color.bg;
};

export enum MITActions {
  DETAILS,
  REFUND,
}

const ActionsAllowedByStatus: Record<MITStatus, MITActions[]> = {
  PAID: [MITActions.DETAILS, MITActions.REFUND],
  FAILED: [MITActions.DETAILS],
  PARTIALLY_REFUNDED: [MITActions.DETAILS, MITActions.REFUND],
  REFUNDED: [MITActions.DETAILS],
};

export const getAllowedMITActions = (status: MITStatus) => ActionsAllowedByStatus[status] ?? [];
